import { useI18n } from '../i18n';
import LogoWhiteTr from '../img/imzayonetlmlogo-beyaz.png';
import LogoBlueTr from '../img/imzayonetimlogo.png';
import LogoWhiteEn from '../img/en-imza-beyaz.png';
import LogoBlueEn from '../img/en-imza-mavi.png';

// The wordmark is localized: "İmza Yönetim Portalı" in Turkish,
// "Signature Manager" in English. `tone` is the logo color — 'white' for
// dark surfaces, 'blue' for light ones.
const LOGOS = {
  tr: { white: LogoWhiteTr, blue: LogoBlueTr, alt: 'Martinci İmza Yönetim Portalı' },
  en: { white: LogoWhiteEn, blue: LogoBlueEn, alt: 'Martinci Signature Manager' },
};

export default function useBrandLogo(tone = 'white') {
  const { lang } = useI18n();
  const set = LOGOS[lang] || LOGOS.tr;
  return { src: set[tone], alt: set.alt };
}
